let moveArr = [


  {
    ele: [".banner .title"],
    distancetop: 0,
    distancebottom: 500,
    from: { opacity: 1, y: 0 },
    to: { opacity: 0, y: -200 }
  },

  {
    ele: [".service .contant .contant-left .title", ".service .contant .contant-left .text"],
    distancetop: 200,
    distancebottom: 100,
    from: { opacity: 0.8, scale: 0.5 },
    to: { opacity: 1, scale: 1 }
  },
  {
    ele: [".service .contant .contant-left .img"],
    distancetop: 200,
    distancebottom: 100,
    from: { opacity: 1, y: -300, x: 1000 },
    to: { opacity: 1, y: 0, x: 0 }
  },

  {
    ele: [".service .contant .contant-right"],
    distancetop: 200,
    distancebottom: 100,
    from: { opacity: 0, y: -300, },
    to: { opacity: 1, y: 0, }
  },
  {
    ele: [".select .subTitle .box1"],
    distancetop: 800,
    distancebottom: 300,
    from: { opacity: 0, scale: 1.5, },
    to: { opacity: 1, scale: 1, }
  },
  {
    ele: [".select .subTitle .box2"],
    distancetop: 1000,
    distancebottom: 300,
    from: { opacity: 0, scale: 1.5, },
    to: { opacity: 1, scale: 1, }
  },
  {
    ele: [".select .subTitle .box3"],
    distancetop: 1200,
    distancebottom: 300,
    from: { opacity: 0, scale: 1.5, },
    to: { opacity: 1, scale: 1, }
  },
  {
    ele: [".select .img"],
    distancetop: 1500,
    distancebottom: 300,
    from: { opacity: 0, x: -1500, },
    to: { opacity: 1, x: 0, }
  },

  {
    ele: [".select .logo"],
    distancetop: 1700,
    distancebottom: 200,
    from: { opacity: 0, y: 1500, },
    to: { opacity: 1, y: 0, }
  },
  // {
  //   ele: [".service .contant .contant-right"],
  //   distancetop: 100,
  //   distancebottom: 300,
  //   from: { opacity: 0, y: -300, },
  //   to: { opacity: 1, y: 0, }
  // },
  // {
  //   ele: [".service .contant .contant-right"],
  //   distancetop: 100,
  //   distancebottom: 300,
  //   from: { opacity: 0, y: -300, },
  //   to: { opacity: 1, y: 0, }
  // },

















]
export default moveArr


//////////////////
// WEBPACK FOOTER
// ./static/movedata/services.js
// module id = null
// module chunks = 